import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ScreenOutfitStyleStyles = styled(OnboardingPage)`
  .local-title {
    margin: 20px auto 40px;
  }
`;
